import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

/**
 * Disable MFA
 */
export default async function disableMFA() {
  const res = await fetchOrchidAPI("/api/users/v1/disable_mfa", {
    method: "POST",
  });
  if (!res.ok) {
    throw new Error(getErrorDetail(await res.text()));
  }
  return;
}
